import {
  SettingsCard,
  SettingsNote,
  SettingsPanel,
  SettingsRow,
} from "../SettingsUI";

export function HelpSection() {
  return (
    <SettingsPanel title="Help and feedback" description="Help centre, contact us, privacy policy">
      <SettingsCard title="Help centre">
        <SettingsRow
          title="Getting started"
          description="Learn how to use Papaya Web on your computer"
        />
        <SettingsRow
          title="Linking your phone"
          description="Scan QR codes and manage linked devices"
        />
        <SettingsRow
          title="Calls and contacts"
          description="Make calls, save contacts, and manage groups"
        />
        <SettingsRow
          title="Troubleshooting"
          description="Fix common login, audio, and notification issues"
        />
      </SettingsCard>

      <SettingsCard title="Contact us">
        <SettingsRow title="Email support" description="support@papaya.cx" />
        <SettingsRow title="Send feedback" description="Tell us what is working and what is not" />
        <SettingsRow title="Report a problem" description="Share logs and steps to reproduce" />
      </SettingsCard>

      <SettingsCard title="Legal">
        <SettingsRow title="Privacy policy" description="How we collect and use your data" />
        <SettingsRow title="Terms of service" description="Rules for using Papaya services" />
        <SettingsRow title="Cookie policy" description="How cookies are used on Papaya Web" />
      </SettingsCard>

      <SettingsCard title="App info">
        <SettingsRow title="App name" description="Papaya Web" />
        <SettingsRow title="Version" description="0.0.0 (web preview)" />
        <SettingsRow title="Channel" description="Local development" />
      </SettingsCard>

      <SettingsNote>
        Help links are static placeholders for the settings UI and can point to live docs later.
      </SettingsNote>
    </SettingsPanel>
  );
}
